var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`btn ${_vm.fullWidth ? 'w-100' : ''}` + _vm.addClass,style:(_vm.cssString),attrs:{"type":"button","disabled":_vm.disabled ||
    _vm.loading ||
    (_vm.dependency !== 'full'
      ? _vm.hasSomeOfDependencies
      : _vm.hasUnresolvedDependencies)},on:{"click":_vm.clicked}},[(!_vm.loading)?_c('div',{staticClass:"buttonText",style:(_vm.textCssString)},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('div',{staticClass:"spinner-border spinner-border-sm",style:(_vm.textCssString),attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }